/** Icons showcase data — from sf-react-app */
import {
  AlertIcon,
  AlertFilledIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  BarIcon,
  BookOpenIcon,
  CalendarIcon,
  DateRangeIcon,
  CheckCircleIcon,
  CheckCircleFilledIcon,
  CircleCheckIcon,
  CheckIcon,
  CompliancePackageDefinitionIcon,
  ComplianceManagementIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CollapseAltIcon,
  CloseIcon,
  CloseFilledIcon,
  CloseCircleIcon,
  CopyLinkIcon,
  DeleteIcon,
  DirectoryIcon,
  DownloadIcon,
  EditIcon,
  ExpandAltIcon,
  FileAltIcon,
  PencilIcon,
  EnvelopeIcon,
  LockIcon,
  LockWithDotIcon,
  ExclamationCircleIcon,
  ExclamationIcon,
  ExclamationTriangleIcon,
  EyeIcon,
  EyeOffIcon,
  FireIcon,
  FilterIcon,
  InfoIcon,
  MinusIcon,
  MonitorIcon,
  OfficeBuildingIcon,
  OpenLinkIcon,
  PauseIcon,
  PlusIcon,
  PlayIcon,
  PlayCircleIcon,
  SearchIcon,
  SparkleIcon,
  SpinnerIcon,
  ThumbsUpIcon,
  UndoIcon,
  UploadIcon,
  UploadLogoIcon,
  UploadVideoIcon,
  VolumeIcon,
  VolumeMuteIcon,
  AiAssistantIcon,
  ArchivedIcon,
  BubbleCheckIcon,
  DownloadToBottomIcon,
  DownloadToTrayIcon,
  UploadToTopIcon,
  FilterLinesIcon,
  GridIcon,
  HomeIcon,
  HistoryIcon,
  MapPinIcon,
  SendPlaneIcon,
  StarIcon,
  TagIcon,
  TrophyIcon,
  TemplateGalleryIcon,
  TileLibraryTrendIcon,
  WidgetsIcon,
} from '../../../design-system/components/Icons';

const DS_ICONS_SHOWCASE = [
  { name: 'AlertFilledIcon', Component: AlertFilledIcon },
  { name: 'AlertIcon', Component: AlertIcon },
  { name: 'ArrowDownIcon', Component: ArrowDownIcon },
  { name: 'ArrowLeftIcon', Component: ArrowLeftIcon },
  { name: 'ArrowRightIcon', Component: ArrowRightIcon },
  { name: 'BarIcon', Component: BarIcon },
  { name: 'BookOpenIcon', Component: BookOpenIcon },
  { name: 'CalendarIcon', Component: CalendarIcon },
  { name: 'DateRangeIcon', Component: DateRangeIcon },
  { name: 'CheckCircleFilledIcon', Component: CheckCircleFilledIcon },
  { name: 'CheckCircleIcon', Component: CheckCircleIcon },
  { name: 'CircleCheckIcon', Component: CircleCheckIcon },
  { name: 'CheckIcon', Component: CheckIcon },
  { name: 'ChevronDownIcon', Component: ChevronDownIcon },
  { name: 'ChevronLeftIcon', Component: ChevronLeftIcon },
  { name: 'ChevronRightIcon', Component: ChevronRightIcon },
  { name: 'CloseCircleIcon', Component: CloseCircleIcon },
  { name: 'CloseFilledIcon', Component: CloseFilledIcon },
  { name: 'CloseIcon', Component: CloseIcon },
  { name: 'CollapseAltIcon', Component: CollapseAltIcon },
  { name: 'CopyLinkIcon', Component: CopyLinkIcon },
  { name: 'ComplianceManagementIcon', Component: ComplianceManagementIcon },
  { name: 'CompliancePackageDefinitionIcon', Component: CompliancePackageDefinitionIcon },
  { name: 'DeleteIcon', Component: DeleteIcon },
  { name: 'DirectoryIcon', Component: DirectoryIcon },
  { name: 'DownloadIcon', Component: DownloadIcon },
  { name: 'EditIcon', Component: EditIcon },
  { name: 'PencilIcon', Component: PencilIcon },
  { name: 'EnvelopeIcon', Component: EnvelopeIcon },
  { name: 'ExclamationIcon', Component: ExclamationIcon },
  { name: 'ExclamationCircleIcon', Component: ExclamationCircleIcon },
  { name: 'ExclamationTriangleIcon', Component: ExclamationTriangleIcon },
  { name: 'EyeIcon', Component: EyeIcon },
  { name: 'EyeOffIcon', Component: EyeOffIcon },
  { name: 'FireIcon', Component: FireIcon },
  { name: 'FilterIcon', Component: FilterIcon },
  { name: 'InfoIcon', Component: InfoIcon },
  { name: 'MinusIcon', Component: MinusIcon },
  { name: 'MonitorIcon', Component: MonitorIcon },
  { name: 'OfficeBuildingIcon', Component: OfficeBuildingIcon },
  { name: 'OpenLinkIcon', Component: OpenLinkIcon },
  { name: 'PauseIcon', Component: PauseIcon },
  { name: 'PlusIcon', Component: PlusIcon },
  { name: 'PlayIcon', Component: PlayIcon },
  { name: 'PlayCircleIcon', Component: PlayCircleIcon },
  { name: 'SearchIcon', Component: SearchIcon },
  { name: 'ThumbsUpIcon', Component: ThumbsUpIcon },
  { name: 'UndoIcon', Component: UndoIcon },
  { name: 'UploadIcon', Component: UploadIcon },
  { name: 'UploadLogoIcon', Component: UploadLogoIcon },
  { name: 'UploadVideoIcon', Component: UploadVideoIcon },
  { name: 'VolumeIcon', Component: VolumeIcon },
  { name: 'VolumeMuteIcon', Component: VolumeMuteIcon },
  { name: 'SpinnerIcon', Component: SpinnerIcon },
  { name: 'AiAssistantIcon', Component: AiAssistantIcon },
  { name: 'ArchivedIcon', Component: ArchivedIcon },
  { name: 'BubbleCheckIcon', Component: BubbleCheckIcon },
  { name: 'DownloadToBottomIcon', Component: DownloadToBottomIcon },
  { name: 'DownloadToTrayIcon', Component: DownloadToTrayIcon },
  { name: 'UploadToTopIcon', Component: UploadToTopIcon },
  { name: 'ExpandAltIcon', Component: ExpandAltIcon },
  { name: 'FileAltIcon', Component: FileAltIcon },
  { name: 'FilterLinesIcon', Component: FilterLinesIcon },
  { name: 'GridIcon', Component: GridIcon },
  { name: 'HomeIcon', Component: HomeIcon },
  { name: 'HistoryIcon', Component: HistoryIcon },
  { name: 'LockIcon', Component: LockIcon },
  { name: 'LockWithDotIcon', Component: LockWithDotIcon },
  { name: 'MapPinIcon', Component: MapPinIcon },
  { name: 'SendPlaneIcon', Component: SendPlaneIcon },
  { name: 'SparkleIcon', Component: SparkleIcon },
  { name: 'StarIcon', Component: StarIcon },
  { name: 'TagIcon', Component: TagIcon },
  { name: 'TrophyIcon', Component: TrophyIcon },
  { name: 'TemplateGalleryIcon', Component: TemplateGalleryIcon },
  { name: 'TileLibraryTrendIcon', Component: TileLibraryTrendIcon },
  { name: 'WidgetsIcon', Component: WidgetsIcon },
];

// ✅ Icon showcase size scale — shows all DS size steps
const ICON_SIZE_SCALE = [
  { label: 'xs', size: 12 },
  { label: 'sm', size: 16 },
  { label: 'md', size: 20 },
  { label: 'lg', size: 24 },
  { label: 'xl', size: 32 },
];

// ✅ Color variants to showcase
const ICON_COLOR_VARIANTS = [
  { label: 'default', className: '' },
  { label: 'muted', className: 'ds-icon--color-muted' },
  { label: 'success', className: 'ds-icon--color-success' },
  { label: 'warning', className: 'ds-icon--color-warning' },
  { label: 'error', className: 'ds-icon--color-error' },
  { label: 'primary', className: 'ds-icon--color-primary' },
];

export { DS_ICONS_SHOWCASE, ICON_SIZE_SCALE, ICON_COLOR_VARIANTS };
